module.exports = __webpack_public_path__ + "img/img09.b889df6f.png";